
import { Component, Vue, Prop } from 'nuxt-property-decorator';
import { RawHtml } from './layout';

@Component({
  components: {
    RawHtml,
  },
})
export default class Tooltip extends Vue {
  @Prop({ type: String, default: undefined }) readonly content!: string;
  @Prop({ type: String, default: 'top' }) readonly placement!: string;
  @Prop({ type: Number, default: 8 }) readonly distance!: number;
  @Prop({ type: Number, default: 25 }) readonly showDelay!: number;
  @Prop({ type: Number, default: 125 }) readonly hideDelay!: number;
  @Prop({ type: Array, default: () => ['hover', 'focus'] }) readonly triggers!: string[];
  @Prop({ type: Array, default: () => ['hover', 'focus'] }) readonly popperTriggers!: string[];
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  public isOpen = false;
}
